<template>

  <v-btn
    icon
    density="compact"
    class="ml-2"
    size="small"
  >

    <v-icon icon="$setAll" />

    <v-menu activator="parent" v-model="menuOpen" location="bottom right" :close-on-content-click="false" :transition="false">
      <v-list style="width: 200px">
        <v-list-item>
          <v-number-input
            :label="$t('titles.set_all_to')"
            v-model.number="cost"
            :precision="2"
            prefix="$"
            density="compact"
            ref="textField"
            :rules="[rules!.required!(), rules!.min!(0.01)]"
          >
            <template v-slot:append>
              <v-btn icon="$ok" @click="() => submit()" />
            </template>
          </v-number-input>
        </v-list-item>
      </v-list>
    </v-menu>

  </v-btn>

</template>

<script setup lang="ts">

import { ref, useTemplateRef, watch } from 'vue'
import { useRules } from 'vuetify/labs/rules'

const rules = useRules()
const emit = defineEmits(['set'])
const menuOpen = ref<boolean>(false)
const cost = ref<number | undefined>()

const textField = useTemplateRef('textField')

watch(textField, (newValue, oldValue) => {
  if (oldValue === null && newValue !== null) {
    textField.value?.focus()
  }
})

async function submit() {

  if (!textField.value) {
    return
  }

  await textField.value?.validate()

  if (!textField.value.isValid) {
    return
  }

  emit('set', cost.value)
  menuOpen.value = false

}

</script>
